<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.paymententry') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header
              :title="$t('message.typeofpaymententry')"
              :subtitle="$t('series.pe') + ' ' + nextPeCode"/>
            <div class="form-row mt-3">
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="formType"
                    style="float: left;padding: 0;"
                    color="#A3CA76"
                    vsValue="pay">
                    <strong>{{ $t('message.checkboxexpense') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.checkboxexpensedetails') }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="formType"
                    style="float: left;padding: 0;"
                    color="#A3CA76"
                    vsValue="receive">
                    <strong>{{ $t('message.checkboxreceive') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.checkboxreceivedetails') }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="mb-3">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.reference')"/>
            <div class="form-row">
              <div class="col-4">
                <label>{{ $t('message.type') }}</label>
                <select
                  :class="[bindClass.doc_type]"
                  v-model="form.doc_type"
                  class="form-control custom-select">
                  <option value="">{{ $t('placeholder.select') }}</option>
                  <option
                    v-if="formType == 'pay'"
                    value="po">{{ $t('documents.po') }} / PO-</option>
                  <option
                    v-if="formType == 'pay'"
                    value="ex">{{ $t('documents.ex') }} / EX-</option>
                  <option
                    v-if="formType == 'pay'"
                    value="prl">{{ $t('documents.prl') }} / PRL-</option>
                  <option
                    v-if="formType == 'receive'"
                    value="in">{{ $t('documents.in') }} / INV-</option>
                </select>
              </div>
              <div
                v-if="form.doc_type != ''"
                class="col-8"
                style="position: relative;">
                <i
                  v-if="loadingPO || loadingIN || loadingEX"
                  class="fas fa-spinner spin"
                  style="position: absolute; top: 34px; right: 36px;"/>
                <template>
                  <label>{{ $t('message.series') }}</label>
                </template>
                <select
                  :class="[bindClass.doc_series]"
                  :disabled="loadingPO || loadingIN || loadingEX"
                  v-model="form.doc_series"
                  class="form-control custom-select">
                  <option value="">{{ $t('placeholder.select') }}</option>
                  <template v-if="form.doc_type == 'po'">
                    <option
                      v-for="(purchase, index) in purchases"
                      :class="[{
                        'text-warning': getPurchaseStatus(purchase, $t, mixin).status == 'padding',
                        'text-success': getPurchaseStatus(purchase, $t, mixin).status == 'completed',
                        'text-info': getPurchaseStatus(purchase, $t, mixin).status == 'uncompleted',
                        'text-danger': getPurchaseStatus(purchase, $t, mixin).status == 'rejected'
                      }]"
                      :disabled="purchase.status != 'approved'"
                      :value="purchase.po_id">
                      {{ purchase.po_code }}
                      ({{ getPurchaseStatus(purchase, $t, mixin).message }})
                    </option>
                  </template>
                  <template v-if="form.doc_type == 'ex'">
                    <option
                      v-for="(expense, index) in expenses"
                      :class="[{
                        'text-warning': getExpenseStatus(expense, $t, mixin).status == 'padding',
                        'text-success': getExpenseStatus(expense, $t, mixin).status == 'completed',
                        'text-info': getExpenseStatus(expense, $t, mixin).status == 'uncompleted',
                        'text-danger': getExpenseStatus(expense, $t, mixin).status == 'rejected'
                      }]"
                      :disabled="expense.status != 'approved'"
                      :value="expense.ex_id">
                      {{ expense.ex_code }}
                      ({{ getExpenseStatus(expense, $t, mixin).message }})
                    </option>
                  </template>
                  <template v-if="form.doc_type == 'in'">
                    <option
                      v-for="(invoice, index) in invoices"
                      :class="[{
                        'text-warning': getInvoiceStatus(invoice, $t, mixin).status == 'padding',
                        'text-success': getInvoiceStatus(invoice, $t, mixin).status == 'completed',
                        'text-info': getInvoiceStatus(invoice, $t, mixin).status == 'uncompleted',
                        'text-danger': getInvoiceStatus(invoice, $t, mixin).status == 'rejected'
                      }]"
                      :disabled="invoice.status != 'approved'"
                      :value="invoice.in_id">
                      {{ invoice.in_code }}
                      ({{ getInvoiceStatus(invoice, $t, mixin).message }})
                    </option>
                  </template>
                  <template v-if="form.doc_type == 'prl'">
                    <option
                      v-for="(item, index) in paySlipList"
                      :class="[{
                        'text-warning': item.process.status == 'pending',
                        'text-success': item.process.status == 'completed',
                        'text-info': item.process.status == 'uncompleted',
                        'text-danger': item.process.status == 'rejected',
                      }]"
                      :disabled="item.status != 'approved'"
                      :value="item.prlId">
                      {{ item.prlCode }}
                      <BaseDocumentProcessStatus
                        :docType="`prl`"
                        :status="item.process.status"
                      />
                    </option>
                  </template>
                </select>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="form.doc_type != '' && form.doc_series != ''"
          class="mb-3">
          <div class="col-md-12 no-padding">
            <section-header :title="sectionHeaderRefCode"/>
            <div class="form-row mt-2">
              <template>
                <div
                  v-if="partnerInfo.vendor !== undefined"
                  class="col-4">
                  <label>{{ $t('message.vendor') }}</label>
                  <input
                    :disabled="true"
                    :value="partnerInfo.vendor ? partnerInfo.vendor.vendor_name : ''"
                    type="text"
                    class="form-control">
                </div>
                <div
                  v-if="partnerInfo.customer !== undefined"
                  class="col-4">
                  <label>{{ $t('message.customer') }}</label>
                  <input
                    :disabled="true"
                    :value="partnerInfo.customer ? partnerInfo.customer.customer_name : ''"
                    type="text"
                    class="form-control">
                </div>
              </template>
              <div class="col-4">
                <label>{{ $t('message.debttotal') }}</label>
                <template>
                  <input
                    v-if="docInfo.po"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getDebtPurchaseAmount(docInfo.po))"
                    type="text"
                    class="form-control text-info">
                  <input
                    v-if="docInfo.in"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getDebtInvoiceAmount(docInfo.in))"
                    type="text"
                    class="form-control text-info">
                  <input
                    v-if="docInfo.ex"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getDebtExpenseAmount(docInfo.ex))"
                    type="text"
                    class="form-control text-info">
                  <input
                    v-if="docInfo.prl"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getDebtPayslipAmount(docInfo.prl))"
                    type="text"
                    class="form-control text-info">
                </template>
              </div>
              <div :class="{'col-md-2': (!docInfo.ex || !docInfo.prl), 'col-md-4': (docInfo.ex || docInfo.prl)}">
                <label>{{ $t('message.paidtotal') }}</label>
                <template>
                  <input
                    v-if="docInfo.po"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getPaidAmount(docInfo.po.reference.payments))"
                    type="text"
                    class="form-control">
                  <input
                    v-if="docInfo.in"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getPaidAmount(docInfo.in.reference.payments))"
                    type="text"
                    class="form-control">
                  <input
                    v-if="docInfo.ex"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getPaidAmount(docInfo.ex.reference.payments))"
                    type="text"
                    class="form-control">
                  <input
                    v-if="docInfo.prl"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(docInfo.prl.net - docInfo.prl.process.debit)"
                    type="text"
                    class="form-control">
                </template>
              </div>
              <div :class="{'col-md-2': (!docInfo.ex || !docInfo.prl), 'col-md-4': (docInfo.ex || docInfo.prl)}">
                <label>{{ $t('message.grandtotal') }}</label>
                <template>
                  <input
                    v-if="docInfo.po"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getTotal(docInfo.po.orders).payment)"
                    type="text"
                    class="form-control">
                  <input
                    v-if="docInfo.in"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(getTotal(docInfo.in.orders).payment)"
                    type="text"
                    class="form-control">
                  <input
                    v-if="docInfo.ex"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(docInfo.ex.payment.amount)"
                    type="text"
                    class="form-control">
                  <input
                    v-if="docInfo.prl"
                    :disabled="true"
                    :value="setToCustomDigitsNumber(docInfo.prl.net)"
                    type="text"
                    class="form-control">
                </template>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.infopayment')"/>
            <div class="form-row mb-2">
              <div class="col-md-4">
                <label>{{ $t('message.type') }}</label>
                <select
                  v-model="form.payment_type"
                  class="form-control custom-select">
                  <option value="cash">{{ $t('message.cash') }}</option>
                  <option value="card">{{ $t('message.creditcard') }}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label>{{ $t('message.paidamount', {string: currency}) }}</label>
                <input
                  :class="[bindClass.payment_amount]"
                  v-model="form.payment_amount"
                  type="text"
                  class="form-control number-only text-select-all"
                  @keypress="numberOnly"
                  @keyup="form.payment_amount = setToValidNumber(form.payment_amount)"
                  @blur="form.payment_amount = setToCustomDigitsNumber(form.payment_amount)">
              </div>
              <div class="col-md-4">
                <label>{{ $t('message.postingpaiddate') }}</label>
                <BaseInputDatePicker
                  v-model="form.payment_date"
                />
              </div>
            </div>
            <div class="form-row mb-3">
              <div class="col-12">
                <label>{{ $t('message.note') }}</label>
                <textarea
                  :placeholder="$t('placeholder.dotted')"
                  v-model="form.note"
                  class="form-control form-control-sm"
                  style="min-height: 90px;"/>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <vs-checkbox
                  v-model="form.ispaid"
                  color="#A3CA76"
                  style="float: left;position: relative;top: 0;left: -5px;">
                  {{ $t('message.ispaid') }}
                </vs-checkbox>
              </div>
            </div>
          </div>
        </section>
        <section class="action-bar">
          <template>
            <div
              v-if="!$store.state.app.loading || !isReadyToSave"
              class="col-md-12 text-right">
              <!-- <button class="btn btn-light btn-block-mobile-only"
                      @click="clearForm()">{{ $t('button.cancel') }}</button> -->
              <div class="btn-group">
                <button
                  :disabled="!isReadyToSave"
                  type="button"
                  class="btn btn-web"
                  @click="save({isCreateAnother: false})">{{ $t('button.save') }}</button>
                <button
                  :disabled="!isReadyToSave"
                  type="button"
                  class="btn btn-web dropdown-toggle dropdown-toggle-split"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    class="dropdown-item"
                    @click="save({isCreateAnother: true})">{{ $t('button.saveandcreateanother') }}</a>
                </div>
              </div>
            </div>
            <div
              v-if="$store.state.app.loading && isReadyToSave"
              class="col-md-12 text-right">
              <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-web"
                  disabled><i class="fas fa-spinner spin"/></button>
                <button
                  type="button"
                  class="btn btn-web dropdown-toggle dropdown-toggle-split"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  disabled>
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu"/>
              </div>
            </div>
          </template>
        </section>
      </template>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'AccountsPaymentEntryNew',
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      formType: 'pay',

      form: {
        doc_type: '',
        doc_series: '',
        payment_type: 'cash',
        payment_amount: 0,
        payment_date: new Date(),
        note: '',
        ispaid: true,
      },

      originalForm: null,

      bindClass: {
        doc_type: '',
        doc_series: '',
        payment_amount: '',
      },

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      loadingPO: false,
      loadingEX: false,
      loadingIN: false,
      loadingPRL: false,
    }
  },
  computed: {
    ...mapState('payroll', {
      paySlipList: 'paySlipList',
      payslip: 'paySlipSingle',
    }),
    ...mapGetters({
      nextPeCode: 'getNextPeCode',
      currency: 'getCurrency',
      dateformat: 'getDateFormat',
      purchases: 'getPurchases',
      invoices: 'getInvoices',
      expenses: 'getExpenses',
      getPurchaseStatus: 'getPurchaseStatus',
      getInvoiceStatus: 'getInvoiceStatus',
      getExpenseStatus: 'getExpenseStatus',
      getPurchaseInfo: 'getPurchaseInfo',
      getInvoiceInfo: 'getInvoiceInfo',
      getExpenseInfo: 'getExpenseInfo',
    }),
    isReadyToSave () {
      if (this.loadingPO || this.loadingEX || this.loadingIN || this.loadingPRL) {
        return false
      }
      return true
    },
    partnerInfo () {
      if (this.form.doc_type == 'po') {
        if (this.form.doc_series) {
          let po_id = this.form.doc_series
          let purchaseInfo = this.getPurchaseInfo(po_id)
          return {
            vendor: purchaseInfo.vendor ? purchaseInfo.vendor : null,
          }
        }
      }
      if (this.form.doc_type == 'in') {
        if (this.form.doc_series) {
          let in_id = this.form.doc_series
          let invoiceInfo = this.getInvoiceInfo(in_id)
          return {
            customer: invoiceInfo.customer ? invoiceInfo.customer : null,
          }
        }
      }
      return {}
    },
    docInfo () {
      if (this.form.doc_type == 'po') {
        if (this.form.doc_series) {
          let po_id = this.form.doc_series
          let purchaseInfo = this.getPurchaseInfo(po_id)
          return {
            po: purchaseInfo,
          }
        }
      }
      if (this.form.doc_type == 'ex') {
        if (this.form.doc_series) {
          let ex_id = this.form.doc_series
          let expenseInfo = this.getExpenseInfo(ex_id)
          return {
            ex: expenseInfo,
          }
        }
      }
      if (this.form.doc_type == 'in') {
        if (this.form.doc_series) {
          let in_id = this.form.doc_series
          let invoiceInfo = this.getInvoiceInfo(in_id)
          return {
            in: invoiceInfo,
          }
        }
      }
      if (this.form.doc_type == 'prl') {
        if (this.form.doc_series) {
          const prlId = this.form.doc_series
          return {
            prl: this.paySlipList.find((item) => item.prlId === prlId),
          }
        }
      }
      return {}
    },
    sectionHeaderRefCode () {
      if (this.docInfo.po) {
        return this.docInfo.po.po_code
      }
      if (this.docInfo.ex) {
        return this.docInfo.ex.ex_code
      }
      if (this.docInfo.in) {
        return this.docInfo.in.in_code
      }
      if (this.docInfo.prl) {
        return this.docInfo.prl.prlCode
      }
      return null
    },
  },
  methods: {
    ...mapActions('payroll', {
      getPaySlipList: 'getPaySlipList',
      getPaySlipSingle: 'getPaySlipSingle',
    }),
    isValid () {
      if (this.bindClass.doc_type == 'is-invalid' ||
         this.bindClass.doc_series == 'is-invalid' ||
         this.bindClass.payment_amount == 'is-invalid') {
        return false
      }
      return true
    },
    validation () {
      if (this.form.doc_type == '') {
        this.bindClass.doc_type = 'is-invalid'
      }
      if (this.form.doc_series == '') {
        this.bindClass.doc_series = 'is-invalid'
      }
      if (this.form.payment_amount == '') {
        this.bindClass.payment_amount = 'is-invalid'
      }
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      // get next code
      await this.$store.dispatch('getNextPeCode')

      that.ready = true

      // scroll to top
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    },
    async save (option = {}) {
      // validation
      this.validation()

      // check valid
      if (!this.isValid()) {
        return false
      }

      let dataSet = {
        'type': this.formType,
        'status': this.form.ispaid ? 'paid' : 'padding',
        'created_at': this.form.payment_date ? this.form.payment_date.toISOString() : this.moment().toISOString(),
        'note': this.form.note.trim().length > 0 ? this.form.note.trim() : null,
        'payment': {
          'type': this.form.payment_type,
          'amount': parseFloat(this.form.payment_amount),
        },
        'reference': {},
        'partner': {},
      }

      if (this.form.doc_type == 'po') {
        dataSet['reference']['po_id'] = this.form.doc_series
      }
      if (this.form.doc_type == 'in') {
        dataSet['reference']['in_id'] = this.form.doc_series
      }
      if (this.form.doc_type == 'ex') {
        dataSet['reference']['ex_id'] = this.form.doc_series
      }
      if (this.form.doc_type == 'prl') {
        dataSet['reference']['prl_id'] = this.form.doc_series
      }

      if (this.partnerInfo.vendor) {
        dataSet['partner']['vendor_id'] = this.partnerInfo.vendor.vendor_id
      }
      if (this.partnerInfo.customer) {
        dataSet['partner']['customer_id'] = this.partnerInfo.customer.customer_id
      }

      let res = await this.$store.dispatch('insertPayment', dataSet)

      if (res.success) {
        let newPayment = res.data.payment

        // show notify payment completed
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newPayment.pe_code }),
          color: 'success',
          icon: 'cloud',
        })

        // show notify purchase completed
        if (this.docInfo.po) {
          // get data info
          let res = await this.$store.dispatch('getPurchase', {
            po_id: this.docInfo.po.po_id,
          })
          if (res.success && res.data.length > 0) {
            let purchase = res.data[0]
            // notify
            if (this.getPurchaseStatus(purchase, this.$t, this.mixin).status == 'completed') {
              let that = this
              let text = that.$t('message.hasbeencompleted', { msg: that.docInfo.po.po_code })
              setTimeout(() => {
                that.notify(that.$vs, {
                  text: text,
                  color: 'success',
                  icon: 'check',
                })
              }, 500)
            }
          }
        }
        // show notify expense completed
        else if (this.docInfo.ex) {
          // get data info
          let res = await this.$store.dispatch('getExpense', {
            ex_id: this.docInfo.ex.ex_id,
          })
          if (res.success && res.data.length > 0) {
            let expense = res.data[0]
            // notify
            if (this.getExpenseStatus(expense, this.$t, this.mixin).status == 'completed') {
              let that = this
              let text = that.$t('message.hasbeencompleted', { msg: that.docInfo.ex.ex_code })
              setTimeout(() => {
                that.notify(that.$vs, {
                  text: text,
                  color: 'success',
                  icon: 'check',
                })
              }, 500)
            }
          }
        }
        // show notify invoice completed
        else if (this.docInfo.in) {
          // get data info
          let res = await this.$store.dispatch('getInvoice', {
            in_id: this.docInfo.in.in_id,
          })
          if (res.success && res.data.length > 0) {
            let invoice = res.data[0]
            // notify
            if (this.getInvoiceStatus(invoice, this.$t, this.mixin).status == 'completed') {
              let that = this
              let text = that.$t('message.hasbeencompleted', { msg: that.docInfo.in.in_code })
              setTimeout(() => {
                that.notify(that.$vs, {
                  text: text,
                  color: 'success',
                  icon: 'check',
                })
              }, 500)
            }
          }
        }
        // show notify payslip completed
        else if (this.docInfo.prl) {
          await this.getPaySlipSingle(this.docInfo.prl.prlId)
          if (this.payslip.process.debit === 0) {
            const text = this.$t('message.hasbeencompleted', { msg: this.docInfo.prl.prlCode })
            const that = this
            setTimeout(() => {
              that.notify(that.$vs, {
                text: text,
                color: 'success',
                icon: 'check',
              })
            }, 500)
          }
        }

        if (!option.isCreateAnother) {
          return this.$router.push({
            name: 'AccountsPaymentEntryEdit',
            query: {
              pe_id: newPayment._id,
              pe_code: newPayment.pe_code,
              ignoreDiscardAlert: true,
            },
          })
        } else {
          // clear form
          this.clearForm()
        }
      }
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    formType: {
      handler: function (after) {
        this.form.doc_type = ''
        this.form.doc_series = ''
      },
      deep: true,
    },
    'form.doc_type': {
      handler: async function (after, before) {
        let val = after

        if (val.length > 0) {
          this.bindClass.doc_type = ''
          // this.bindClass.doc_series = 'is-invalid'
        } else {
          // this.bindClass.doc_type = 'is-invalid'
          this.bindClass.doc_series = ''
        }

        // set default value
        this.form.doc_series = ''
        this.form.payment_amount = 0

        if (val == 'po') {
          if (this.purchases.length == 0) {
            // start loading
            this.loadingPO = true
            // get purchases
            await this.$store.dispatch('getPurchases')
            // stop loading
            this.loadingPO = false
            this.showFinish(this.$Progress)
          }
        } else if (val == 'in') {
          if (this.invoices.length == 0) {
            // start loading
            this.loadingIN = true
            // get invoices
            await this.$store.dispatch('getInvoices')
            // stop loading
            this.loadingIN = false
            this.showFinish(this.$Progress)
          }
        } else if (val == 'ex') {
          if (this.expenses.length == 0) {
            // start loading
            this.loadingEX = true
            // get expenses
            await this.$store.dispatch('getExpenses')
            // stop loading
            this.loadingEX = false
            this.showFinish(this.$Progress)
          }
        } else if (val == 'prl') {
          // start loading
          this.loadingPRL = true
          // get payslips
          await this.getPaySlipList({ page: 1, limit: 100000 })
          // stop loading
          this.loadingPRL = false
          this.showFinish(this.$Progress)
        }
      },
      deep: true,
    },
    'form.doc_series': {
      handler: function (after, before) {
        let val = after
        if (val.length > 0) {
          this.bindClass.doc_series = ''
        } else {
          if (this.doc_type != '') {
            // this.bindClass.doc_series = 'is-invalid'
          }
        }

        this.form.payment_amount = 0

        if (this.docInfo.po) {
          this.form.payment_amount = this.getDebtPurchaseAmount(this.docInfo.po)
        } else if (this.docInfo.in) {
          this.form.payment_amount = this.getDebtInvoiceAmount(this.docInfo.in)
        } else if (this.docInfo.ex) {
          this.form.payment_amount = this.getDebtExpenseAmount(this.docInfo.ex)
        } else if (this.docInfo.prl) {
          this.form.payment_amount = this.getDebtPayslipAmount(this.docInfo.prl)
        }
      },
      deep: true,
    },
    'form.payment_amount': {
      handler: function (after, before) {
        let val = parseFloat(after)
        if (isNaN(val)) {
          this.bindClass.payment_amount = 'is-invalid'
        } else {
          this.bindClass.payment_amount = ''
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat
    // set payment_amount
    this.form.payment_amount = this.setToCustomDigitsNumber(this.form.payment_amount)
    // set originalForm
    this.originalForm = _.cloneDeep(this.form)
    // get next code
    await this.$store.dispatch('getNextPeCode')
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 1,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearPurchases', 'clearInvoices', 'clearExpenses'])
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/accounts/paymententry/New.vue